import React from 'react';
import { useSymbolSearchModule } from '../../Modules';
import {
  SymbolSearchItemData,
  SymbolSearchItem,
  createSymbolSearchItem,
  isSymbolSearchItem,
  SearchItem,
} from '@benzinga/search-modules';
import { TokenData } from '../tokenize';
import { ExpressionModule, ExpressionSearchModule } from './ExpressionModules';

export interface SymbolExpressionData {
  leftOperand: 'Tickers.name';
  operator: 'array';
  rightOperand: string;
}

export interface SymbolExpressionModule extends ExpressionModule<SymbolSearchItemData> {
  toTokenData: (item: SearchItem) => SymbolExpressionData | undefined;
  fromTokenData: (token: TokenData<unknown>) => SymbolSearchItem | undefined;
}

export const isSymbolExpressionData = (token: TokenData<unknown>): token is SymbolExpressionData => {
  return token.leftOperand === 'Tickers.name' && token.operator === 'array';
};

export const createSymbolExpressionModule = (): SymbolExpressionModule => {
  return {
    fromTokenData: token => {
      if (!isSymbolExpressionData(token)) return undefined;
      return createSymbolSearchItem(token.rightOperand);
    },
    toTokenData: item => {
      if (!isSymbolSearchItem(item)) return undefined;
      return {
        leftOperand: 'Tickers.name',
        operator: 'array',
        rightOperand: item.data.symbol,
      };
    },
  };
};

export const useSymbolExpressionSearchModule = (): ExpressionSearchModule => {
  const symbolModule = useSymbolSearchModule();
  return React.useMemo(() => ({ ...symbolModule, expression: createSymbolExpressionModule() }), [symbolModule]);
};
